import React, { useState, useEffect } from 'react';
import { useAuth } from '../auth/AuthProvider';
import AppearanceService from '../../services/AppearanceService';
import './Header.css';

const Header = ({ isMobile, sidebarOpen = true, toggleSidebar }) => {
  const { user, logout } = useAuth();
  const [shopName, setShopName] = useState('Ma Boutique');
  const [showUserMenu, setShowUserMenu] = useState(false);

  useEffect(() => {
    // Charger le nom de la boutique
    const loadShopName = async () => {
      try {
        const shopData = await AppearanceService.getShopAppearance();
        if (shopData?.name) {
          setShopName(shopData.name);
        }
      } catch (error) {
        // Ignorer les erreurs silencieusement
        console.log('Impossible de charger le nom de la boutique');
      }
    };

    loadShopName();
  }, []);

  const handleLogout = async () => {
    await logout();
    // Rediriger vers l'app principale après déconnexion
    window.location.href = process.env.REACT_APP_PUBLIC_URL || process.env.REACT_APP_APP_URL || 'http://app.local.dev:8080';
  };

  // Obtenir les initiales de l'utilisateur
  const getUserInitials = () => {
    if (!user) return '?';

    if (user.first_name && user.last_name) {
      return `${user.first_name.charAt(0)}${user.last_name.charAt(0)}`.toUpperCase();
    }
    if (user.email) {
      return user.email.charAt(0).toUpperCase();
    }
    return 'U';
  };

  // Obtenir le nom complet de l'utilisateur
  const getUserDisplayName = () => {
    if (!user) return 'Utilisateur';

    if (user.first_name && user.last_name) {
      return `${user.first_name} ${user.last_name}`;
    }
    if (user.first_name) {
      return user.first_name;
    }
    if (user.email) {
      return user.email.split('@')[0];
    }
    return 'Utilisateur';
  };

  return (
    <header className="main-header">
      <div className="header-content">
        {(isMobile || !sidebarOpen) && (
          <button
            type="button"
            className="mobile-menu-btn"
            onClick={toggleSidebar}
            aria-label="Ouvrir le menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
        )}

        <div className="header-title">
          <h1>{shopName}</h1>
          <span className="header-badge">Shop Admin</span>
        </div>

        <div className="header-actions">
          <div className="header-user-container">
            <div
              className="header-user"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              <div className="user-avatar">{getUserInitials()}</div>
              <div className="user-info">
                <span className="user-name">{getUserDisplayName()}</span>
                {user?.roles?.includes('creator') && (
                  <span className="user-role">Créateur</span>
                )}
              </div>
              <svg
                className={`user-menu-arrow ${showUserMenu ? 'open' : ''}`}
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>

            {showUserMenu && (
              <>
                <div className="user-menu-overlay" onClick={() => setShowUserMenu(false)}></div>
                <div className="user-menu">
                  <div className="user-menu-header">
                    <span className="user-menu-email">{user?.email}</span>
                  </div>
                  <div className="user-menu-divider"></div>
                  <a
                    href={process.env.REACT_APP_PUBLIC_URL || process.env.REACT_APP_APP_URL || 'http://app.local.dev:8080'}
                    className="user-menu-item"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                      <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                    Retour à l'application
                  </a>
                  <button
                    className="user-menu-item logout"
                    onClick={handleLogout}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                      <polyline points="16 17 21 12 16 7"></polyline>
                      <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>
                    Déconnexion
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
